import { createFileRoute } from '@tanstack/react-router'
import GlossaryPage from '@/pages/glossary'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/glossary/'
)({
  component: GlossaryPage,
})
